const shopNavigation = {
  displayField: 'title',
  name: 'Shop Navigation',
  description: 'Navigation for shops',
  fields: [
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { unique: true } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'topLevelNav',
      name: 'Top Level Nav',
      type: 'Array',
      localized: false,
      required: false,
      validations: [
        {
          size: { min: null, max: 3 },
          message: 'There are to many links in this navigation, you can not have more than 3'
        }
      ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'navLink' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'shopNavigation',
    version: 2,
    updatedAt: '2023-05-26T14:24:27.151Z'
  }
};
export default shopNavigation;